import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationService, AppLanguage } from '../../../shared/services/translation.service';
import { DropdownSelectComponent } from '../dropdown-select/dropdown-select.component';
import { OptionsModel } from '../../../types/options.model';

/** Flag emoji + native label for each supported language */
const LANG_META: Record<AppLanguage, { flag: string; label: string }> = {
  es: { flag: '🇪🇸', label: 'Español' },
  en: { flag: '🇬🇧', label: 'English' },
  pt: { flag: '🇧🇷', label: 'Português' },
  fr: { flag: '🇫🇷', label: 'Français' },
  it: { flag: '🇮🇹', label: 'Italiano' },
  de: { flag: '🇩🇪', label: 'Deutsch' },
  ar: { flag: '🇸🇦', label: 'العربية' },
};

@Component({
  selector: 'app-language-selector',
  standalone: true,
  imports: [CommonModule, DropdownSelectComponent],
  templateUrl: './language-selector.component.html',
  styleUrl: './language-selector.component.scss',
})
export class LanguageSelectorComponent {
  private t = inject(TranslationService);

  currentLang = this.t.lang;

  /** Languages mapped to OptionsModel for app-dropdown-select */
  get langOptions(): OptionsModel[] {
    return this.t.getLanguages().map(l => {
      const meta = LANG_META[l.code];
      return new OptionsModel(
        l.code,                              // name
        `${meta?.flag ?? ''} ${l.label}`,    // label  (flag + native name)
        l.code,                              // value
      );
    });
  }

  /** Called by dropdown-select when a language is picked */
  onLangChange(value: string): void {
    if (value) {
      this.t.setLanguage(value as AppLanguage);
    }
  }
}
